import React from "react";

const MemberCard = ({ member }) => {
  return (
    <div className="bg-white rounded-lg shadow-sm overflow-hidden flex flex-col justify-between items-center p-6 min-h-[26rem] w-full sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto transition-transform transform hover:scale-105 duration-300 ease-in-out">
      <div className="flex flex-col items-center w-full">
        {/* Responsive image */}
        <img
          src={member.photo}
          alt={member.name}
          className="w-24 h-24 sm:w-28 sm:h-28 md:w-32 md:h-32 rounded-full object-cover mb-4 shadow-sm"
        />

        {/* Responsive text sizes */}
        <h2 className="text-lg sm:text-xl md:text-2xl font-semibold mb-3 text-center text-gray-900 ">
          {member.name}
        </h2>

        {/* Position or Type */}
        <p className="text-gray-900 font-bold tracking-wide bg-gray-200 px-3 py-1 rounded-sm text-center mb-2">
          {member.position || member.type}
        </p>

        {/* Major/Field of Study */}
        <p className="text-sm sm:text-center md:text-lg text-gray-700 ">
          {member.major}
        </p>

        {/* University and Course Info */}
        <div className="text-center">
          <p className="text-sm sm:text-base md:text-lg text-gray-700  ">
            {member.courseAcronym} - {member.year}
          </p>
          <p className="text-sm sm:text-base md:text-lg text-gray-700 ">
            {member.university}
          </p>
        </div>
      </div>

      {/* Button to open profile */}
      <div className="w-full mt-3">
        <button
          onClick={() => window.open(member.profileLink, "_blank")}
          className="bg-blue-500 text-white font-bold w-full py-2 rounded-md hover:bg-blue-600 transition duration-300 flex items-center justify-center"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="h-5 w-5 mr-2"
          >
            <path d="M15 3h6v6"></path>
            <path d="M10 14 21 3"></path>
            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
          </svg>
          Connect
        </button>
      </div>
    </div>
  );
};

export default MemberCard;
